import Vue from 'vue'
import {i18n} from '@/i18n'

export default {
    namespaced: true,
    state: {
        lang: i18n.locale,
    },
    actions: {
        changeLang({commit, dispatch}, locale) {
            if (!locale) return
            commit('setLang', locale)
            dispatch('cabinet/constants/fetchConstants', locale, {root: true});
        }
    },
    mutations: {
        setLang(state, locale) {
            i18n.locale = locale;
            Vue.prototype.$moment.locale(locale);
            state.lang = locale;
        },
    },
};
